import { Routes } from '@angular/router';
import { CheckoutPage } from './checkout.page';

export const checkoutRoutes: Routes = [
    {
        path: '',
        component: CheckoutPage,
    },
];
